import moment from 'moment';

function formatTime(timestamp) {
  const currentTime = timestamp ? moment(timestamp) : moment().local();
  const currentTimeZone = currentTime.format('Z'); // +08:00
  // output: 10:46 AM, 3 Nov 2020 (GMT +8)
  return `${currentTime.format('LT, D MMM YYYY')} (GMT ${currentTimeZone.substr(0, 1)}${Number(currentTimeZone.substr(1, 2))})`;
}

export default formatTime;